// Add your custom JS here.
import Modal from 'bootstrap/js/dist/modal';

// Gallery Lightbox (with prev/next navigation)
(function() {
	const galleryLinks = document.querySelectorAll('.gallery-lightbox');
	if (galleryLinks.length === 0) return;

	const lightboxEl = document.getElementById('galleryLightbox');
	if (!lightboxEl) return;

	const lightboxImage = document.getElementById('lightboxImage');
	const lightboxModal = new Modal(lightboxEl);
	let currentIndex = 0;
	let galleryImages = [];

	// Build array of gallery images
	galleryLinks.forEach(function(link, index) {
		galleryImages.push(link.getAttribute('href'));
		
		link.addEventListener('click', function(e) {
			e.preventDefault();
			currentIndex = index;
			lightboxImage.src = galleryImages[currentIndex];
			lightboxModal.show();
		});
	});

	// Previous button
	document.getElementById('lightboxPrev').addEventListener('click', function() {
		currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
		lightboxImage.src = galleryImages[currentIndex];
	});

	// Next button
	document.getElementById('lightboxNext').addEventListener('click', function() {
		currentIndex = (currentIndex + 1) % galleryImages.length;
		lightboxImage.src = galleryImages[currentIndex];
	});

	// Keyboard navigation
	document.addEventListener('keydown', function(e) {
		if (!lightboxEl.classList.contains('show')) return;
		
		if (e.key === 'ArrowLeft') {
			currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
			lightboxImage.src = galleryImages[currentIndex];
		} else if (e.key === 'ArrowRight') {
			currentIndex = (currentIndex + 1) % galleryImages.length;
			lightboxImage.src = galleryImages[currentIndex];
		}
	});
})();

// Single Image Lightbox (no navigation)
(function() {
	const singleLinks = document.querySelectorAll('.single-lightbox');
	if (singleLinks.length === 0) return;

	const lightboxEl = document.getElementById('singleLightbox');
	if (!lightboxEl) return;

	const lightboxImage = document.getElementById('singleLightboxImage');
	const lightboxModal = new Modal(lightboxEl);

	singleLinks.forEach(function(link) {
		link.addEventListener('click', function(e) {
			e.preventDefault();
			lightboxImage.src = link.getAttribute('href');
			lightboxModal.show();
		});
	});
})();